export default "__VITE_ASSET__BjuLKgev__"